// 获取时区
function getTimeZoneInfo() {
    return new Promise(function (resolve) {
        try {
            let isiOS = sessionStorage.getItem('isiOS') === 'true' ? true : false;
            if (!isiOS) {
                const timezone =window.MobvoiJSBridge.getTimeZone()
                console.log('android getTimeZone',timezone)
                resolve(timezone)
            } else {
                try {
                    window.webkit.messageHandlers.getTimeZone.postMessage('getTimeZone');
                    window.getTimeZone = function (value) {
                        console.log('ios getTimeZone==>',value)
                        resolve(value)
                    }
                } catch(e) {
                    //console.log('报错误，内层', e)
                    resolve(false)
                }
            }
        } catch(err) {
            // console.log('报错误，外层', err)
            resolve(false)
        }
    })
}


function eventTracking (currentPath,event, params={}) {
    try {
        const data = {"currentPath": currentPath, "event": event, "params": params }
        let isiOS = sessionStorage.getItem('isiOS') === 'true' ? true : false;
        if (!isiOS) {
            let androidData = JSON.stringify(data)
            console.log('埋点数据', androidData)
            window.MobvoiJSBridge.reportEvent(androidData);
        } else {
            console.log('埋点数据', data)
            window.webkit.messageHandlers.reportEvent.postMessage(data);
        }
    } catch(err) {
        console.log('埋点报错', err)
    }

}

function getLocalPathIds(pathIds){
    return new Promise(function (resolve) {
        try {
            let params = JSON.stringify(pathIds)
            window.webkit.messageHandlers.getAppLocalPath.postMessage(params);
            window.getAppLocalPath = function (value) {
                console.log('ios getAppLocalPath==>',value)
                resolve(value)
            }

        } catch(err) {
            console.log('ios getAppLocalPath 报错==>',err)
            resolve("")
        }
    })
}

function getPackageName(){
    return new Promise(function (resolve) {
        try {
            let isiOS = sessionStorage.getItem('isiOS') === 'true' ? true : false;
            if (!isiOS) {
                let packageName =window.MobvoiJSBridge.getPackageName()
                packageName = packageName.length ?  packageName.replace(/^\s+|\s+$/g,"") : packageName
                console.log('android getPackageName',packageName)
                resolve(packageName)
            } else {
                try {
                    window.webkit.messageHandlers.getPackageName.postMessage('getPackageName');
                    window.getPackageName = function (value) {
                        value = value.length ? value.replace(/^\s+|\s+$/g,"") : value
                        console.log('ios getPackageName==>',value)
                        resolve(value)
                    }
                } catch(e) {
                    // console.log('报错误，内层', e)
                    resolve('')
                }
            }
        } catch(err) {
            // console.log('报错误，外层', err)
            resolve('')
           // resolve('com.mobvoi.companion.at')
        }
    })
}

// 获取ios活动商品
function getActivityProducts() {
    return new Promise(function (resolve) {
        try {
            try {
                window.webkit.messageHandlers.getActivityProducts.postMessage('getActivityProducts');
                window.getActivityProducts = function (value) {

                    console.log('ios getActivityProducts==>',value)
                    let finalRes = getDecode(value)
                    console.log('ios finalRes==>',finalRes)
                    resolve(finalRes)
                }
            } catch(e) {
                console.log('getActivityProducts报错误，内层', e)
                resolve(false)
            }
        } catch(err) {
            console.log('getActivityProducts报错误，外层', err)
            resolve(false)
        }
    })
}

// ios的二进制数据转成数组
export function getDecode(str) {
    let decodeStr = decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    console.log('decodeStr', decodeStr)
    return JSON.parse(decodeStr)
}

export { getTimeZoneInfo, eventTracking, getLocalPathIds, getPackageName, getActivityProducts }
